import { Button } from '@amore/ui/components/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@amore/ui/components/tooltip'
import { PencilLine } from 'lucide-react'
import type { Ref } from 'react'
import { useCanEdit } from '@/mock/store'

export function CeremonyEditAction({
  label,
  onClick,
  id,
  ref,
}: {
  label: string
  onClick: () => void
  id?: string
  ref?: Ref<HTMLButtonElement>
}) {
  const canEdit = useCanEdit()
  if (!canEdit) return null
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          ref={ref}
          id={id}
          appearance="ghost"
          tone="neutral"
          size="icon"
          className="size-9"
          aria-label={label}
          onClick={onClick}
        >
          <PencilLine className="size-4" aria-hidden="true" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  )
}
